import { Popover, PopoverProps } from 'antd';
import Bg from 'assets/images/page/403.png';
import classnames from 'classnames';
import React, { Children, Fragment, useEffect } from 'react';
import  WarmingFill from '@/assets/images/icons/warming-fill.react.svg?react';
import { ReportGuideType } from '@/config/app/auth';
import { BASE_NAME } from '@/infrastructure/history';
import { getProductId } from '@/infrastructure/product-info';
import { CUSTOM_ACTIONS } from '@/infrastructure/reporter/datong/constant';
import { reportClick } from '@/infrastructure/reporter/datong/report';
import styles from '@/presentation/components/free-product-guide/index.module.scss';
import { Icon } from '@/presentation/components/icon';
import { ModalMsg, ModalType } from '@/presentation/components/modal-msg';
import { useStores } from '@/presentation/store';
import { ProductType } from '@/service/product-permissions';
import { useTranslation } from 'react-i18next';


export enum GuideType {
  MODAL = 1, // 弹窗引导
  POP_CONFIRM = 2, // 气泡引导
  CARD = 3 // 卡片引导
}

export enum Display {
  BLOCK = 1, // 块元素
  INLINE = 2 // 行内元素
}

interface IProps {
  guideType: GuideType; // 引导类型
  reportGuideType?: ReportGuideType;
  children?: React.PropsWithChildren<any>;
  content?: React.ReactNode | string;// 自定义提示信息
  showPro?: {styles: React.CSSProperties}; // 是否显示[专]字
  display?: Display; // 用于包裹子节点的元素类型
  openGuide?: boolean;// 是否开启引导，默认开启，用来处理循环组件
  className?: string;
  popoverProps?: PopoverProps;
  reportScene?: string
  reportField?: string;
}

export const getUrl = () => {
  const productId = getProductId();
  return  `${location.origin}${BASE_NAME}/resource-pack${productId ? `?appId=${productId}` : ''}`;
};
// 免费版升级引导
const FreeProductGuide = (props: IProps) => {
  const { t } = useTranslation();
  const { children,
    guideType,
    content,
    showPro,
    display,
    openGuide = true,
    className,
    popoverProps,
    reportGuideType,
    reportScene,
    reportField } = props;
  const { productType } = useStores().ProductStore;
  const { pgid } = useStores().LayoutStore;


  const childClick = () => {
    reportClick(reportScene!, CUSTOM_ACTIONS.guideUpgradeView, {
      from: pgid,
      param3: reportGuideType,
      param4: reportField,
    });
    const url = getUrl();
    ModalMsg({
      type: ModalType.CONFIRM,
      title: '',
      okText: t("购买资源包"),
      content: content ?? <span className={'text-[#4A5970]'}>{t("体验产品不支持此功能，请")}<a target='_blank' href={url} onClick={() => reportClick(reportScene!, CUSTOM_ACTIONS.guideUpgradeClick, {
        from: pgid,
        param3: reportGuideType,
        param4: reportField,
      })}>{t("购买资源包")}</a>{t("，升级为付费产品后再使用。")}</span>,
      onOk: () => {
        const a = document.createElement('a');
        a.href = url;
        a.target = '_blank';
        a.click();
        reportClick(reportScene!, CUSTOM_ACTIONS.guideUpgradeClick, {
          from: pgid,
          param3: reportGuideType,
          param4: reportField,
        });
      },
    });
  };


  const confirmContent = (
    <div className={'flex items-start'}>
      <Icon className={'mt-[3px] mr-[8px]'}><WarmingFill/></Icon>
      <span className={'flex-1 text-[14px] text-[#4A5970]'}>{t("体验产品不支持此功能，请")}<a target="_blank" href={getUrl()} onClick={() => reportClick(reportScene!, CUSTOM_ACTIONS.guideUpgradeClick, {
        from: pgid,
        param3: reportGuideType,
        param4: reportField,
      })}>{t("购买资源包")}</a>{t("，升级为付费产品后再使用。")}</span>
    </div>
  );

  // 判断为免费版,且开启引导，覆盖节点点击事件
  if (productType === ProductType.FREE_PRODUCT && openGuide) {
    // 没有节点默认为卡片引导
    if (Children.count(children) === 0) {
      return <CardGuide content={content} reportGuideType={reportGuideType}
      reportScene={reportScene}
      reportField = {reportField} pgid={pgid}/>;
    }

    switch (guideType) {
      case GuideType.MODAL:
        // 判断是否为普通文本
        if (typeof(children) === 'string') {
          return React.cloneElement(
            <span className={classnames({
              [styles.guideItem]: true,
              [styles.proTxtContainer]: showPro,
            })}>
              {children}
              {showPro ? <div style={showPro?.styles} className={styles.proTxt}>{t("专")}</div> : null}
            </span>,
            { onClick: childClick },
          );
        }
        return Children.map(children, child => <>
            {!display ? React.cloneElement(child, { onClick: childClick }) : null}
            {display === Display.INLINE
              ? <span className={classnames(styles.guideItem, className)}>
                {React.cloneElement(child, { onClick: childClick })}
            </span>
              : null}
            {display === Display.BLOCK
              ? <div className={classnames(styles.guideItem, className)}>
                {React.cloneElement(child, { onClick: childClick })}
            </div>
              : null}
          </>);
      case GuideType.POP_CONFIRM:
        // 判断是否为普通文本
        if (typeof(children) === 'string') {
          return <Popover overlayClassName={styles.overlayClassName}
                          destroyTooltipOnHide
                          title=""
                          zIndex={10000}
                          content={content ?? confirmContent}
                          onVisibleChange={(visible) => {
                            if (visible) {
                              reportClick(reportScene!, CUSTOM_ACTIONS.guideUpgradeView, {
                                from: pgid,
                                param3: reportGuideType,
                                param4: reportField,
                              });
                            }
                          }}
                          {...popoverProps}
          >
            {React.cloneElement(
              <span  className={classnames(styles.guideItem, className)}>{children}</span>,
              { onClick: () => {} },
            )}
          </Popover>;
        }
        return Children.map(children, child => <>
          <Popover overlayClassName={styles.overlayClassName}
                   destroyTooltipOnHide
                   title=""
                   zIndex={10000}
                   content={content ?? confirmContent}
                   onVisibleChange={(visible) => {
                     if (visible) {
                       reportClick(reportScene!, CUSTOM_ACTIONS.guideUpgradeView, {
                         from: pgid,
                         param3: reportGuideType,
                         param4: reportField,
                       });
                     }
                   }}
                   {...popoverProps}
          >
            {!display ? React.cloneElement(
              child,
              { onClick: () => {} },
            ) : null}
            {display === Display.INLINE ? <span className={classnames(styles.guideItem, className)}>
              {React.cloneElement(
                child,
                { onClick: () => {}, disabled: true },
              )}</span> : null}
            {display === Display.BLOCK ? <div className={classnames({
              [styles.guideItem]: true,
              [className || '']: true,
              [styles.proTxtContainer]: showPro })}>
              {React.cloneElement(
                child,
                { onClick: () => {}, disabled: true, style: {
                  ...child.props.style,
                  cursor: 'not-allowed',
                } },
              )}
              {showPro ? <div style={showPro?.styles} className={styles.proTxt}>{t("专")}</div> : null}
            </div> : null}
          </Popover>
        </>);
      case GuideType.CARD:
      default:
        return <CardGuide content={content} reportGuideType={reportGuideType}
        reportScene={reportScene}
        reportField = {reportField} pgid={pgid} />;
    }
  }


  return (
    <Fragment>
      {children}
    </Fragment>
  );
};

const CardGuide = (props: {content?: React.ReactNode | string, reportGuideType?: ReportGuideType, reportScene?: string
  reportField?: string;pgid?: string}) => {
  const { t } = useTranslation();
  useEffect(() => {
    reportClick(props.reportScene!, CUSTOM_ACTIONS.guideUpgradeView, {
      from: props.pgid,
      param3: props.reportGuideType,
      param4: props.reportField,
    });
  }, [props.reportScene]);
  return <div
  className={'bg-[#fff] w-full h-full flex items-center justify-center flex-col p-[24px]'}>
  <img className={'w-[200px] h-[200px]'} src={Bg} alt={t("背景图片")} />
  <div className={'text-[#4A5970] w-[320px] text-center'}>
      {props.content ? <span>{props.content}</span> : <span>{t("体验产品不支持此功能，请")}<a target='_blank' href={getUrl()} onClick={() => reportClick(props.reportScene!, CUSTOM_ACTIONS.guideUpgradeClick, {
        from: props.pgid,
        param3: props.reportGuideType,
        param4: props.reportField,
      })}>{t("购买资源包")}</a>{t("，升级为付费产品后再使用。")}</span>}
    </div>
</div>;
};

export default FreeProductGuide;
